var render = function render(){var _vm=this,_c=_vm._self._c;return _c('AhaInfoBox',[_vm._v("\n  "+_vm._s(_vm.$i18nPresenter.t("Answers are not case-sensitive, e.g. “iPhone” and “iphone” are the same. You can accept more answers while presenting."))+"\n")])
}
var staticRenderFns = []

export { render, staticRenderFns }